import { useEffect, useRef, useState } from 'react';
import { AdvisoryContent } from '../global-types/AdvisoryContent';
import useIsInViewport from '../useIsInViewport';
import APIUtil from '../api/APIUtil';

type EventType = 'loaded' | 'visible';

function useTracking(content: AdvisoryContent, viewId: number | undefined) {
  const [hasFiredVisibleEvent, setHasFiredVisibleEvent] = useState<boolean>(false);
  const trackVisibilityElement = useRef(null);
  const isInViewport = useIsInViewport(trackVisibilityElement, viewId !== undefined);

  useEffect(() => {
    if (content.initialView !== viewId) return;
    const eventType: EventType  = 'loaded';
    const contentView = content.contentViews?.find((cv) => cv.contentViewId === viewId);
    if (contentView?.tracking) {
      if (contentView.tracking.payload) {
        APIUtil.handleCallback(`${contentView.tracking.baseUrl}${contentView?.tracking.callbackPath}`, { ...contentView.tracking.payload, eventType })
      } else {
        APIUtil.handleCallbackUrl(
          contentView?.tracking.baseUrl,
          `${contentView?.tracking.callbackPath}&eventType=${eventType}`
        );
      }
    }
  }, [content]);

  useEffect(() => {
    setHasFiredVisibleEvent(false);
  }, [viewId]);

  useEffect(() => {
    if (isInViewport && !hasFiredVisibleEvent && viewId) {
      const eventType: EventType = 'visible';

      const contentView = content.contentViews?.find((cv) => cv.contentViewId === viewId);

      if (contentView?.tracking) {
        if (contentView.tracking.payload) {
          APIUtil.handleCallback(`${contentView.tracking.baseUrl}${contentView?.tracking.callbackPath}`, { ...contentView.tracking.payload, eventType })
        } else {
          APIUtil.handleCallbackUrl(
            contentView?.tracking.baseUrl,
            `${contentView?.tracking.callbackPath}&eventType=${eventType}`
          );
        }
      }

      setHasFiredVisibleEvent(true);
    }
  }, [isInViewport, hasFiredVisibleEvent, content, viewId]);

  return trackVisibilityElement;
}

export default useTracking;
